import { StocksAssets } from "@/app/stocks/icm 3.0/stocks-assets";
import { BROKING_MARGIN_SHEET_URL } from "@/app/stocks/constants/broking-external-links";

export type KnowMoneyBetterVisualBg = "midnight" | "neutral";

export type KnowMoneyBetterCta =
    | { type: "external"; label: string; href: string }
    | { type: "login"; label: string };

export type KnowMoneyBetterSlide = {
    id: string;
    visualTitle: string;
    visualDescription: string;
    visualBg: KnowMoneyBetterVisualBg;
    illustrationDesktop: string;
    illustrationMobile: string;
    overline: string;
    title: string;
    description: string;
    features: readonly string[];
    cta: KnowMoneyBetterCta;
};

/**
 * Know Your Money Better carousel — Figma web 8168:87480 / slides 8177:30692, 8190:92272 / mobile 2541:36047, 4679:29063
 */
export const KNOW_MONEY_BETTER_SLIDES: readonly KnowMoneyBetterSlide[] = [
    {
        id: "mtf",
        visualTitle: "The lowest rate,\nforged for you.",
        visualDescription:
            "By balancing buying power with smart collateral, traders unlock more upside while keeping financing cost low at just 12.5% per annum.",
        visualBg: "midnight",
        illustrationDesktop: StocksAssets.mtfIllustration,
        illustrationMobile: StocksAssets.mtfIllustration,
        overline: "MARGIN TRADING FACILITY",
        title: "More buying power",
        description:
            "One of the lowest MTF rates available in India. Hold your delivery positions longer without heavy financing cost.",
        features: [
            "Stocks + Extra Buying Power",
            "Equity+ Delivery with 4x Funding",
            "Collateral Pledge (₹15+GST)",
            "Margin Before Entry calculator",
            "Across NSE & BSE",
        ],
        cta: {
            type: "external",
            label: "View the latest sheet",
            href: BROKING_MARGIN_SHEET_URL,
        },
    },
    {
        id: "scalper",
        visualTitle: "Trade faster with confidence",
        visualDescription:
            "Execute trades with speed and precision through a seamless trading experience designed for active market participants.",
        visualBg: "neutral",
        illustrationDesktop: StocksAssets.scalperIllustration,
        illustrationMobile: StocksAssets.scalperIllustration,
        overline: "SCALPER",
        title: "Stay ahead of every market move",
        description:
            "Built for active traders seeking faster execution and a responsive trading experience to capitalize on short-term opportunities.",
        features: [
            "Fast order execution",
            "Quick entry & exit",
            "Seamless trading experience",
        ],
        cta: {
            type: "login",
            label: "Start Trading",
        },
    },
] as const;
